import eyeIconDisabled from "./eye_disabled_icon_24px.png";
import eyeIconEnabled from "./eye_enabled_icon_24px.png";

type EyeIconProps = {
  enabled?: boolean;
};

export const EyeIcon = ({ enabled }: EyeIconProps) => (
  <img src={enabled ? eyeIconEnabled : eyeIconDisabled} alt="Eye icon" height={24} />
);